import React from "react";
import { RenderKilogramo } from "../../../Utils/renderField/renderReadField";

export const VaciadosCell = ({ productos }) => {
    const hayVaciados = productos.some(
        (producto) => producto.vaciados && producto.vaciados.length > 0,
    );

    if (!hayVaciados) {
        return <div>—</div>;
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            {productos.map((producto) =>
                producto.vaciados.map((vaciado) => (
                    <div key={`${producto.id}-${vaciado.id}`}>
                        <strong>
                            {vaciado.bodega
                                ? vaciado.bodega.nombre
                                : "Sin bodega"}
                        </strong>
                        {" — "}
                        <RenderKilogramo
                            value={vaciado.peso_neto || 0}
                            decimalScale={2}
                        />
                    </div>
                )),
            )}
        </div>
    );
};
